var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M5.947.02h15.089c3.331-.025 5.99 2.618 5.99 5.966v15.061A5.934 5.934 0 0 1 21.036 27H5.947C2.727 27 .028 24.34.028 21.047V5.986C.028 2.638 2.727-.042 5.947.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M22.814 22.083s-1.052-1.703-2.772-1.703c-1.756 0-2.623 1.703-6.097 1.703-7.54 0-11.113-6.203-11.195-6.35 0 .043.042.043.042.043L0 12.842V5.964C0 2.632 2.722 0 5.927 0h5.394l3.937 4.032c.004 0 .004-.042.043-.082 8.939 6.177 6.057 12.86 6.057 12.86s2.475 2.803 1.456 5.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M15.345 4.013c8.908 6.064 6.03 12.78 6.03 12.78s2.476 2.827 1.462 5.307c0 0-1.053-1.722-2.77-1.722-1.72 0-2.75 1.722-6.104 1.722-7.637 0-11.125-6.368-11.125-6.368 6.773 4.61 11.506 1.342 11.506 1.342-3.104-1.797-9.71-10.272-9.71-10.272 5.708 4.792 8.135 6.06 8.135 6.06-1.434-1.14-5.52-7.06-5.52-7.06 3.328 3.304 9.855 7.988 9.855 7.988 1.797-5.196-1.759-9.777-1.759-9.777Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 15.922,
    x2: 11.132,
    y1: -0.091,
    y2: 27.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 14.103,
    x2: 10.137,
    y1: -0.206,
    y2: 22.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23629"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27.026v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/Swift.70482b5e5e59a8117ae6c44e6727911c.svg";
export { ForwardRef as ReactComponent };